module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Regular.91e7eb63.woff";